export default __webpack_public_path__ + "static/media/6.204a36a8.jpeg";